import { EnhancedCheckboxRHF, RHookFormNumberFieldWithLabel } from "@websential/cosmic-v20";

import { FC } from "react";
import { Grid } from "@mui/material";
import { IDropDownListResponse } from "../../../models/common/IDropDownListResponse";

interface IReimbursementsSetupFieldsPanel {
  reimbursementsFieldsList: IDropDownListResponse[]
}
export const ReimbursementsSetupFieldsPanel: FC<
  IReimbursementsSetupFieldsPanel
> = ({ reimbursementsFieldsList }) => {
  return (
    <>
      {reimbursementsFieldsList && reimbursementsFieldsList.length > 0 && reimbursementsFieldsList.map((item: any) => {
        return (
          <RHookFormNumberFieldWithLabel id={`${item.value}-reimbursements`} testId={`${item.label}`} label={`${item.label}`} />
        )
      })}
    </>
  );
};
